import { chatStats, exportChats, hasContent } from '../lib/chatLog.ts';
import type { AppCtx } from './ctx.ts';
import { button, h } from './dom.ts';

/**
 * „Dziennik rozmów” w ekranie Dla rodzica: licznik i kopiowanie rozmów do wklejenia w rozmowie z Claude (do strojenia bota).
 * Dane zostają w przeglądarce; kopiowanie to Twoja decyzja. Tryb testowy (przyciski „dobra / zła odpowiedź” przy bocie) włącza się razem z dziennikiem prób.
 */
export function renderChatPanel(ctx: AppCtx): HTMLElement {
  const store = ctx.chat?.store;
  if (!store) return h('div', { class: 'diag-box', hidden: true });

  const info = h('p', { class: 'muted', 'data-testid': 'chats-count' });
  const status = h('p', { class: 'muted', 'data-testid': 'chats-status' });
  const text = h('textarea', { class: 'attempts-text', readonly: true, rows: 6, hidden: true, 'data-testid': 'chats-text', 'aria-label': 'Rozmowy do skopiowania' });

  // bot w zadaniach (SPEC §14.5): reakcje po próbach, pytania dziecka, komentarz na koniec lekcji
  const coach = ctx.chat?.coach;
  const coachNote = h('p', { class: 'muted', 'data-testid': 'coach-note' });
  const onCoachChange = (e: Event) => {
    coach?.set((e.target as HTMLInputElement).checked);
    coachNote.textContent = coach?.enabled() ? 'Bot będzie się odzywał w zadaniach.' : 'Bot nie będzie się odzywał w zadaniach (zostają gotowe linijki z nagraniami).';
  };
  const coachBox = coach
    ? h('label', { class: 'row coach-toggle' }, h('input', { type: 'checkbox', 'data-testid': 'coach-toggle', ...(coach.enabled() ? { checked: true } : {}), onchange: onCoachChange }), ' 🤖 Bot w zadaniach (reaguje na próby, odpowiada na pytania dziecka)')
    : null;

  const refresh = () => {
    const s = chatStats(store.list());
    info.textContent = `Zapisane rozmowy: ${s.chats}${s.ok + s.bad > 0 ? ` (oceny bota: dobra ${s.ok}, zła ${s.bad})` : ''}. Przyciski oceny przy bocie pojawiają się w trybie testowym (włączasz go wyżej).`;
  };

  const copy = button('📋 Kopiuj rozmowy', async () => {
    const list = store.list();
    const n = list.filter(hasContent).length;
    if (n === 0) {
      status.textContent = 'Brak rozmów z odpowiedziami dziecka. Porozmawiaj z botem i wróć tutaj.';
      return;
    }
    const out = exportChats(list);
    text.value = out;
    text.hidden = false;
    let copied = false;
    try {
      await navigator.clipboard.writeText(out);
      copied = true;
    } catch {
      /* brak uprawnień do schowka — tekst jest w polu poniżej */
    }
    status.textContent = copied ? `Skopiowano ${Math.min(n, 10)} rozmów. Wklej je w rozmowie z Claude.` : 'Nie udało się użyć schowka — zaznacz tekst poniżej (przytrzymaj, „Zaznacz wszystko”) i skopiuj ręcznie.';
  }, { class: 'btn ghost', testid: 'chats-copy' });

  const clearBtn = button('🗑 Wyczyść dziennik rozmów', () => {
    if (!confirm('Usunąć wszystkie zapisane rozmowy z tego urządzenia?')) return;
    store.clear();
    text.hidden = true;
    status.textContent = 'Dziennik rozmów wyczyszczony.';
    refresh();
  }, { class: 'btn link danger', testid: 'chats-clear' });

  refresh();
  return h('div', { class: 'diag-box', 'data-testid': 'chats-panel' }, h('strong', null, '💬 Dziennik rozmów z botem'), coachBox, coachNote, info, copy, status, text, clearBtn);
}
